import React, { useState } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import ArrowBarUp from '@mui/icons-material/ArrowUpward';
import ReactDOMServer from 'react-dom/server';
import Loader from '../../common-components/loader';
import TableView from '../../Components/tableView';
import constants from '../../constants';
import { promoteSensor } from '../../api/sensors';
import { Container } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CustomAlert from '../../Components/CustomAlert';

const TempSensors = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [showError, setShowError] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>();

  const { t } = useTranslation();

  const arrow = () => ReactDOMServer.renderToStaticMarkup(<ArrowBarUp color='info'/>);

  const promote = async (e: Event, cell: any) => {
    const sensor = cell.getRow().getData();
    // Check - To go live sensor must have sensorId - type - NFT - device_num - Algo account
    // Algo account must have initialized planets and nft!
    if (
      sensor.sensor_id &&
      sensor.type &&
      sensor.NFTassetID &&
      sensor.device_number 
    ) {
      setLoading(true);

      try {
        const promSensor = await promoteSensor(sensor.id);
        if (promSensor.data.success) {
          cell.getRow().delete();
          setLoading(false);
        }
      } catch (error: any) {
        setErrorMessage(error.response.data.errorMessage);
        setShowError(true);
        setLoading(false);
      }
    } else {
      setErrorMessage(t('MISSING_DATA_TO_GO_LIVE'));
      setShowError(true);
    }
  };

  const columns = [
    {
      title: t('SENSOR_ID'),
      field: 'sensor_id',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('TYPE'),
      field: 'type',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('ICCID'),
      field: 'iccid',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('ALGORAND_ACCOUNT'),
      field: 'algo_account',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('ALGORAND_INFRASTRUCTURE_ACCOUNT'),
      field: 'algo_account_infra',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('NFT'),
      field: 'NFTassetID',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('DEVICE_NUM'),
      field: 'device_number',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('INFRASTRUCTURE_PERCENTAGE'),
      field: 'infrastructure_percentage',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      formatter: arrow,
      hozAlign: 'center',
      cellClick: promote,
      headerSort: false
    }
  ];

  return (
    <Container>
      <Loader fullscreen={true} visible={loading} />
      <TableView
        t={t}
        api={constants.api.getTempSensors}
        columns={columns}
        id={'sensors-temp-list'}
      />
      <CustomAlert
        show={showError}
        message={errorMessage}
        onClose={() => {
          setErrorMessage(undefined);
          setShowError(false);
        }}
      />
    </Container>
  );
};

export default TempSensors;
